import theme from '@styles/theme';
import { BASE_PATH } from '@config/index';
const mapHeight = (layoutBarsTotalHeight = 146) => ({
  small: ['100vw', '100vw', '100vw', '100vw', `calc(100vh - ${layoutBarsTotalHeight}px)`],
  medium: ['100vw', '100vw', '100vw', '100vw', `calc(100vh - ${layoutBarsTotalHeight}px)`],
  large: ['100vw', '100vw', '100vw', '100vw', `calc(100vh - ${layoutBarsTotalHeight}px)`]
});
export default {
  googleMap: (active: boolean, size: 'small' | 'medium' | 'large', layoutBarsTotalHeight = 146) => ({
    background: theme.rawColors.lightGrey300,
    width: '100%',
    height: active ? mapHeight(layoutBarsTotalHeight)[size] : 0,
    minHeight: active ? ['150px', '150px', '200px', '200px', '800px'] : 'unset',
    '.map-info': {
      display: 'inline-block',
      padding: 0,
      p: {
        margin: '10px 0'
      },
      ':before': {
        content: '""',
        backgroundImage: `url(${BASE_PATH}/img/logo.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        float: 'left',
        width: '90px',
        minHeight: '110px',
        margin: 'auto 20px auto 0'
      }
    },
    '.clusterer': {
      textAlint: 'top'
    }
  })
};